<template>
    <div class="modal-wrapper" 
        :class="{ hide: !modals.bankoPspRequest }" 
        v-on:click.stop="hideModal"
    >
        <div class="modal ElevationDark__3" v-on:click.stop>
            <BaseModalTitle class="title">
                <template #left>
                    <h4 class="title__large">{{ 'Deposit Response' }}</h4>
                </template>
            </BaseModalTitle>
            <div class="content body__medium">
                <template v-if="modalBankoPspRequest.errorMessage">
                    <div class="content-error">
                        <span>Error:</span> 
                        <div class="content-value">{{ modalBankoPspRequest.errorMessage }}</div>
                    </div>
                </template>
                <template v-else>
                    <div 
                        class="content-row" 
                        v-for="(value, label) in modalBankoPspRequest" 
                        :key="label"
                    >
                        <div class="content-label">
                            {{ tokens.bankoPspRequestModal[label] }}
                            <BaseIconButton 
                                v-if="label === 'CVU' && value" 
                                @click.native.stop="copy(value)"
                            >
                                <template #icon>
                                    <i class="material-symbols-outlined" style="font-size: 12px;">content_copy</i>
                                </template>
                            </BaseIconButton>
                        </div>
                        <div class="content-value">
                            {{ label === 'expiresIn' ? expiresInComputed : value }}
                        </div>
                </div>
                </template>
            </div>
            <div class="actions">
                <BaseButton 
                    :button-style="'filled-primary'" 
                    :button-text="'Done'"
                    @click.native="hideModal()"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { MODAL, MODAL_BANKO_PSP_REQUEST,NOTIFICATION } from '@/store/mutations.type'
import BaseButton from "@/new-design/shared/ui/buttons/BaseButton.vue";
import BaseModalTitle from "@/new-design/shared/ui/titles/BaseModalTitle.vue";
import BaseIconButton from "@/new-design/shared/ui/buttons/BaseIconButton.vue";

export default {
    name: "BankoPspRequestModal",
    components: { BaseButton, BaseModalTitle, BaseIconButton },
    data() {
        return {
            remainingSeconds: 0,
            intervalId: null,
        }
    },
    computed: {
        ...mapGetters(['modals', 'tokens','modalBankoPspRequest']),
        expiresInComputed() {
            const totalSeconds = this.remainingSeconds
            const hours = Math.floor(totalSeconds / 3600)
            const minutes = Math.floor((totalSeconds % 3600) / 60)
            const seconds = totalSeconds % 60

            if (hours > 0) {
                return `${hours.toString().padStart(2,'0')}:${minutes.toString().padStart(2,'0')}:${seconds.toString().padStart(2,'0')}`
            } else {
                return `${minutes}:${seconds.toString().padStart(2,'0')}`
            }
        }

    },
    methods: {
        hideModal() {
            this.$store.commit(MODAL, {
                bankoPspRequest: false
            })
            this.$store.commit(MODAL_BANKO_PSP_REQUEST, {
                id: '',
                order_id: '',
                amount: '',
                CVU: '',
                fullname: '',
                status: '',
                detail: ''
            })
        },
        startTimer(seconds) {
            this.stopTimer();
            this.remainingSeconds = seconds;

            this.intervalId = setInterval(() => {
                if (this.remainingSeconds > 0) {
                    this.remainingSeconds--
                } else {
                    this.stopTimer()
                }
            }, 1000)
        },
        stopTimer() {
            if (this.intervalId) {
                clearInterval(this.intervalId)
                this.intervalId = null
            }
        },
        copy(text){
            navigator.clipboard.writeText(text)
                .then(() => {
                    this.$store.commit(NOTIFICATION, 'Copied!')
                })
        },
    },
    watch: {
        'modalBankoPspRequest': {
            deep: true,
            immediate: true,
            handler(value) {
                if (value.expiresIn && Number(value.expiresIn) > 0) {
                    this.startTimer(Number(value.expiresIn) * 60)
                } else {
                    this.stopTimer()
                    this.remainingSeconds = 0
                }
            }
        }
    },
    beforeUnmount() {
        this.stopTimer()
    }
    
}
</script>

<style scoped>
.modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal {
    width: 360px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: var(--System-Surface3);
    border-radius: var(--Corner-small);
    z-index: 1100;
}

.title {
    padding: 24px;
    color: var(--System-OnSurface);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.content {
    padding: 14px 24px 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.content-row {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.content-label {
    color: var(--System-OnSurface);
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
    button{
        margin-top: -2px;
    }
}

.content-value {
    word-break: break-all;
    text-align: right;
    display: flex;
    align-items: center;
}

.content-error{
    display: flex;
    align-items: center;
    gap: 12px;
    span {
        color: var(--System-OnSurface);
    }
}

.actions {
    display: flex;
    justify-content: flex-end;
    padding: 24px;
    margin-top: 24px;
    border-top: 1px solid var(--System-OutlineVariant);
}
</style>
